"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProofInputs = void 0;
const ints_sequence_1 = require("../ints-sequence");
const bytes_1 = require("../bytes");
const __1 = require("../..");
/**
 * Produces the input data for the account and storage proof verification methods in Herodotus
 * @param blockNumber Block Number that the proof targets
 * @param proofs Proofs object from RPC call
 * @returns ProofInputs object
 */
const getProofInputs = (blockNumber, proofs) => {
    const accountProofArray = proofs.accountProof.map((node) => ints_sequence_1.IntsSequence.fromBytes((0, bytes_1.hexToBytes)(node)));
    let accountProof = [];
    for (const node of accountProofArray) {
        accountProof = accountProof.concat(`0x${node.values.length.toString(16)}`, ...__1.encoding.reverseByteOrder(node.values));
    }
    if (proofs.storageProof.length > 1) {
        throw new Error('Multiple storage proofs not yet supported');
    }
    const storageProofArray = proofs.storageProof[0].proof.map((node) => ints_sequence_1.IntsSequence.fromBytes((0, bytes_1.hexToBytes)(node)));
    let storageProof = [];
    for (const node of storageProofArray) {
        storageProof = storageProof.concat(`0x${node.values.length.toString(16)}`, ...__1.encoding.reverseByteOrder(node.values));
    }
    return {
        blockNumber,
        accountProofSubArrayLength: accountProofArray.length,
        accountProof,
        storageProofSubArrayLength: storageProofArray.length,
        storageProof,
    };
};
exports.getProofInputs = getProofInputs;
